import { redirectRouteTemplate } from './templates.ts';

export const genericRoutes = [
  {
    path: '/',
    component: () => import('../views/IndexView.vue'),
  },
  {
    path: '/pricing',
    component: () => import('../views/PricingView.vue'),
    meta: {
      layout: 'MarketingLayout',
      title: 'Pricing',
    },
  },
  redirectRouteTemplate('/faq', 'https://support.rackmanage.io/', 'FAQ'),
  redirectRouteTemplate('/privacy', 'https://support.rackmanage.io/a/privacy-policy-pc1Wm8sfpaFVzRdDU7Ng', 'Privacy Policy'),
  redirectRouteTemplate('/terms', 'https://support.rackmanage.io/a/terms-conditions-NmhpArzd8amJw9UlVvXS', 'Terms of Service'),
  redirectRouteTemplate('/cookies', 'https://support.rackmanage.io/a/cookie-policy-8UzDSpagFzTuURJ6Hp36', 'Cookie Policy'),
  redirectRouteTemplate('/subprocessors', 'https://support.rackmanage.io/a/subprocessors-4oK6Y3lNmp1BmCuTSz60', 'Subprocessors'),
  {
    path: '/cookie-consent',
    props: { showBackButton: true },
    meta: {
      layout: 'MarketingLayout',
      title: 'Cookies',
    },
    component: () => import('../views/ManageCookiesView.vue'),
  },
  {
    path: '/api/health',
    component: () => import('../views/HealthView.vue'),
  },
];
